import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}


const getGroupList = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETDeviceGroup(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};


const addGroup = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTDeviceGroup(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};

const editGroup = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.PUTDeviceGroup(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const delGroup = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.DELETEDeviceGroup(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const GETDevice = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETDevice(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const GETDeviceAlgorithmModelDevice = (params?: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETDeviceAlgorithmModelDevice(params || {});
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const GETDeviceFourGDevice = (params?: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETDeviceFourGDevice(params || {});
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const PUTDevice = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.PUTDevice(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const PUTDeviceFourGStatus = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.PUTDeviceFourGStatus(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const PUTDeviceAlgorithmModel = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.PUTDeviceAlgorithmModel(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const POSTDevice = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTDevice(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const DELETEDevice = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.DELETEDevice(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 批量上传
const POSTAsyTaskImport = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTAsyTaskImport(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 批量下发白名单
const POSTDeviceImportWhitelist = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTDeviceImportWhitelist(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 批量解绑
const POSTDeviceNoBindDevices = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTDeviceNoBindDevices(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 批量修改
const POSTDeviceEditDevices = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTDeviceEditDevices(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 批量换组
const POSTDeviceChangeDevicesGroup = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTDeviceChangeDevicesGroup(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 批量切换版本信息
const PUTDeviceBatchAlgorithmModel = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.PUTDeviceBatchAlgorithmModel(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 手动下发设备OSS
const POSTDeviceOss = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTDeviceDownloadOss(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};

const updateDeviceStatus = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.GETGlobalQDevStatusBySn(params);
    const result = handleRes(res, {
      failMes: res.msg,
    });
    resolve(result);
  });
};

const checkDeviceNew = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.GETDeviceCheckDeviceNew(params);
    const result = handleRes(res, {
      failMes: res.msg,
    });
    resolve(result);
  });
};


const deviceTimeUpdateSubmit = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.POSTDeviceDownloadTime(params);
    const result = handleRes(res, {
      failMes: res.msg,
    });
    resolve(result);
  });
};

// 获取升级任务列表
const GETDeviceUpgradeList = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.GETDeviceUpgradeList(params);
    const result = handleRes(res, {
      failMes: res.msg,
    });
    resolve(result);
  });
};


export {
    getGroupList,
    addGroup,
    editGroup,
    delGroup,
    GETDevice,
    GETDeviceAlgorithmModelDevice,
    GETDeviceFourGDevice,
    DELETEDevice,
    POSTDevice,
    PUTDevice,
    PUTDeviceFourGStatus,
    PUTDeviceAlgorithmModel,

    POSTAsyTaskImport, // 批量上传
    POSTDeviceImportWhitelist,
    POSTDeviceNoBindDevices,
    POSTDeviceEditDevices,
    POSTDeviceChangeDevicesGroup,
    checkDeviceNew,
    deviceTimeUpdateSubmit,
    GETDeviceUpgradeList,
    PUTDeviceBatchAlgorithmModel,
    POSTDeviceOss,
    updateDeviceStatus
};
